import { AxiosResponse } from 'axios';
import { IReturnSalesOrderRequestsResponse } from '../types/api/orderRequestsApi';
import { getAuthToken } from '../utils/commonHelper';
import { ITableRequestData } from '../types/common';
import { toast } from 'react-toastify';
import axiosInstance from '../utils/AxiosInstance';

const API_URL = `${process.env.REACT_APP_API_URL}/return-sale-order`; // Replace with your actual API URL


const customHeaders = {
    'content-type': 'application/json',
};

export const createReturnOrderToSapService = async (
    data: any,
    id: string
): Promise<AxiosResponse<IReturnSalesOrderRequestsResponse>> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/sap/create-return-sap-order/${id}`;

        const response = await axiosInstance.post(url, data, {
            headers: {
                ...customHeaders,
                Authorization: `Bearer ${getAuthToken()}`,
            },
        });

        return response;
    } catch (error: any) {
        throw error;
    }
};

export const getReturnSalesOrderTableService = async ({ limit, page, status,order_type }: ITableRequestData): Promise<AxiosResponse<IReturnSalesOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}`;

        if (limit !== undefined && page !== undefined) url += `?limit=${limit}&page=${page}&status=${status}&order_type=${order_type}`;


        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const getReturnSalesOrderByIdService = async ({ id }: { id: string }): Promise<AxiosResponse<IReturnSalesOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}/${id}`;
        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const updateReturnSalesOrderService = async ({ id, data }: { id: string, data: any }): Promise<AxiosResponse<IReturnSalesOrderRequestsResponse>> => {
    try {
        let url = `${API_URL}/${id}`;
        const response = await axiosInstance.put(url, data, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        if (response.status) {
            toast.success('Return Sales Order updated successfully');
        }
        return response;
    } catch (error: any) {
        throw error;
    }
};
